import React from 'react';
import Message from '../jo-components/misc/message/message';
import AttendeeDetailAnswer from '../jo-components/misc/attendee-detail-item/attendeeDetailAnswer';
import Button from '../jo-components/ui/button/button';
import './waitingListConfirmation.css';

export default function ConfirmStep({config = {}, onSubmit = () => {}}) {
    const details_title = config.waiting_list_confirmation.confirmation_detail.title;
    const title = config.waiting_list_confirmation.header.title;
    const subtitle = config.waiting_list_confirmation.header.subtitle;
    const informationTitle = config.waiting_list_confirmation.message_success.title;
    const informationDescription = config.waiting_list_confirmation.message_success.subtitle;

    const confirmationDetail = config.waiting_list_confirmation.confirmation_detail.details;
    const goBackLabel = config.waiting_list_confirmation.next_step_cta;

    const _onSubmit = React.useCallback(() => {
        onSubmit({
            data: {
                action: 'TicketMarketResale'
            }
        })
    }, [onSubmit]);

    return (
        <div className='neo-confirm-step'>
            <h1 className='neo-rate-step-rates-title'>{title}</h1>
            <h2 className='neo-rate-step-rates-subtitle'>{subtitle}</h2>
            <Message type='success' title={informationTitle} description={informationDescription}/>
            <dl className='waiting-list-confirmation'>
                <h4>{details_title}</h4>
                {confirmationDetail.map((answer, i) => <AttendeeDetailAnswer answer={answer} key={i}/>)}
            </dl>
            <div className='neo-cta-container'>
                <Button type='primary' className='neo-cta-next' onClick={_onSubmit} label={goBackLabel}/>
            </div>
        </div>
    )
}